// extracted by mini-css-extract-plugin
export default {"input":"Input_input__03HvB","medium":"Input_medium__xjg7F","large":"Input_large__pf9bD"};